import React from 'react';
import Icon from '../../../components/AppIcon';

const UploadedPhotoThumb = ({ photo, onRemove }) => {
  const isUploaded = photo?.status === 'done';
  const isUploading = photo?.status === 'uploading';
  const isError = photo?.status === 'error';

  return (
    <div className="relative group rounded-xl overflow-hidden bg-muted aspect-square">
      <img
        src={photo?.preview}
        alt={photo?.file?.name || 'Uploaded photo'}
        className="w-full h-full object-cover"
      />
      {/* Status overlay */}
      {isUploading && (
        <div className="absolute inset-0 bg-black/50 flex flex-col items-center justify-center gap-2">
          <div className="w-6 h-6 border-2 border-white/30 border-t-white rounded-full animate-spin" />
          <span className="text-white text-xs font-medium">{photo?.progress || 0}%</span>
        </div>
      )}
      {isError && (
        <div className="absolute inset-0 bg-red-900/70 flex items-center justify-center">
          <Icon name="AlertCircle" size={20} className="text-white" />
        </div>
      )}
      {isUploaded && (
        <div className="absolute top-1.5 right-1.5 w-5 h-5 bg-emerald-500 rounded-full flex items-center justify-center">
          <Icon name="Check" size={11} className="text-white" />
        </div>
      )}
      {/* Remove button */}
      {!isUploading && (
        <button
          onClick={() => onRemove?.(photo?.id)}
          className="absolute top-1.5 left-1.5 w-6 h-6 bg-black/60 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity hover:bg-red-500"
        >
          <Icon name="X" size={12} className="text-white" />
        </button>
      )}
      {/* File name */}
      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent px-2 py-1.5 opacity-0 group-hover:opacity-100 transition-opacity">
        <p className="text-white text-xs truncate">{photo?.file?.name}</p>
      </div>
    </div>
  );
};

export default UploadedPhotoThumb;
